// Phase 6 — Track E T-E3. cn() — class composition helper.
//
// `clsx` handles conditional / nested input shapes; `tailwind-merge`
// resolves Tailwind class conflicts (later class wins for the same
// utility group, e.g. `p-2 p-4` → `p-4`). Every primitive consumes this
// for its own className merging.

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
